import { render, staticRenderFns } from "./WorkerShow.vue?vue&type=template&id=77736ba2&"
import script from "./WorkerShow.vue?vue&type=script&lang=js&"
export * from "./WorkerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports